/**
 * Module des traverses pour la double poutre
 * Point d'entrée principal pour tous les exports du module
 */

// Types et interfaces
export * from './types';

// Services
export { TraversesDoublePoutre3DService } from './services/TraversesDoublePoutre3DService';

// Composants
export { TraversesDoublePoutreModule } from './components/TraversesDoublePoutreModule';

// Configuration par défaut
export {
  PARAMETRES_DEFAUT_TRAVERSES_DOUBLE_POUTRE,
  CONTRAINTES_TRAVERSES_DOUBLE_POUTRE
} from './types';

// Configuration Canvas 2D (pour les motifs personnalisés)
export const CONFIGURATION_CANVAS_2D_TRAVERSES_DOUBLE_POUTRE = {
  largeur: 400,
  hauteur: 300,
  couleurFond: '#f8f9fa',
  couleurGrille: '#dee2e6',
  couleurTrait: '#007bff',
  epaisseurTrait: 2,
  tailleGrille: 20,
  zoom: {
    min: 0.5,
    max: 3.0,
    defaut: 1.0,
    step: 0.1
  },
  outils: {
    ligne: true,
    courbe: true,
    effacer: true,
    deplacer: true
  }
};